import type { PropertyDto, TransactionItemDto, UnitDto } from '~/swagger/portal/Api';

export type TenantPaymentWithRelations = TransactionItemDto & {
  property?: PropertyDto | null;
  unit?: UnitDto | null;
};

export const buildTenantPaymentDisplay = (payment?: TenantPaymentWithRelations) => ({
  property: payment?.property ?? undefined,
  unit: payment?.unit ?? undefined,
  unitImage: {
    id: payment?.unit?.id ?? payment?.unitId,
    imageId: payment?.unit?.imageId ?? undefined,
  },
});
